module.exports = __webpack_public_path__ + "img/maths.e3024e1a.png";